import axios from 'axios';
import { setTokenHeadersToLocalStorage, getTokenHeadersFromLocalStorage } from 'hooks/useTokens';
import humps from 'humps';
import qs from 'qs';

const setupInterceptors = () => {
  if (axios.interceptors.request.handlers.length === 0) {
    axios.interceptors.request.use(
      config => {
        // eslint-disable-next-line no-param-reassign
        config.headers = {
          ...config.headers,
          ...getTokenHeadersFromLocalStorage(),
        };

        return config;
      },
      error => Promise.reject(error),
    );
  }
  const setHeaders = response => {
    if (response && response.headers['access-token']) {
      setTokenHeadersToLocalStorage(response.headers);
    }
  };
  if (axios.interceptors.response.handlers.length === 0) {
    axios.interceptors.response.use(
      response => {
        setHeaders(response);
        return response;
      },
      error => {
        setHeaders(error.response);
        return Promise.reject(error);
      },
    );
  }
  return axios;
};

const axiosWithInterceptors = setupInterceptors();

const headersMultipartFormData = () => {
  return {
    Accept: '*/*',
    'X-Requested-With': 'XMLHttpRequest',
    'Access-Control-Allow-Origin': '*',
  };
};

export default {
  get(url, attributes, options = {}) {
    return axiosWithInterceptors
      .get(url, {
        params: humps.decamelizeKeys(attributes),
        paramsSerializer: parameters => qs.stringify(parameters, { encode: false, arrayFormat: 'brackets' }),
      })
      .then(response => {
        if (options.rawData) {
          return response;
        }
        return humps.camelizeKeys(response.data);
      });
  },

  post(url, attributes) {
    return axiosWithInterceptors
      .post(url, humps.decamelizeKeys(attributes, { split: /(?=[A-Z0-9])/ }))
      .then(response => {
        return humps.camelizeKeys(response.data);
      });
  },

  put(url, attributes) {
    return axiosWithInterceptors
      .put(url, humps.decamelizeKeys(attributes, { split: /(?=[A-Z0-9])/ }))
      .then(response => {
        return humps.camelizeKeys(response.data);
      });
  },

  delete(url, attributes) {
    return axiosWithInterceptors.delete(url, humps.decamelizeKeys(attributes)).then(response => {
      return humps.camelizeKeys(response.data);
    });
  },

  putWithHeaders(url, attributes, headers) {
    const instance = axios.create();
    return instance.put(url, humps.decamelizeKeys(attributes), { headers }).then(response => {
      return humps.camelizeKeys(response.data);
    });
  },

  postMultipartFormData(url, formData, options = {}) {
    return axiosWithInterceptors
      .post(url, formData, {
        headers: headersMultipartFormData(),
        withCredentials: false,
        credentials: 'same-origin',
        ...options,
      })
      .then(response => humps.camelizeKeys(response.data));
  },

  toRawFormData(blob, attributes) {
    const formData = new FormData();
    Object.keys(attributes).forEach(k => formData.append(k, attributes[k]));
    formData.append('file', blob);
    return formData;
  },
};



// WEBPACK FOOTER //
// ./src/utils/FetchHelpers.js